import CatalogBreadcrumb from './CatalogBreadcrumb';

export default CatalogBreadcrumb;
